import React from "react";
import { observer } from "mobx-react";
import { Button, Typography } from "@mui/material";
import { useRootStore } from "../../../store/contexts";
import { CircularProgress } from "@mui/material";
import { InfoIcon } from "../../../icons";
import Stack from "@mui/material/Stack";

type StatusButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
};

export const StatusButton: React.FC<StatusButtonProps> = observer(
  ({ onClick, disabled, label = false }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    if (onClick) {
      return (
        <Button
          variant={"action"}
          size={prefStore.toolbarSize}
          startIcon={<CircularProgress size={15} thickness={3} color="info" />}
          disabled={disabled === undefined ? false : disabled}
          onClick={onClick}
        >
          {!label ? "" : label}
        </Button>
      );
    } else {
      return (
        <Stack alignItems="center" direction="row" marginLeft={1}>
          <InfoIcon color={"disabled"} fontSize={"small"} />
          <Typography color={"disabled"} variant="body2">
            {label}
          </Typography>
        </Stack>
      );
    }
  }
);
